"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.querystringify = exports.querystring = exports.DomoEvents = void 0;
var MicroEvent = /** @class */ (function () {
    function MicroEvent() {
        this.events = {};
    }
    /* eslint-disable-next-line @typescript-eslint/ban-types */
    MicroEvent.prototype.bind = function (event, fct) {
        var _a;
        connect();
        this.events[event] = (_a = this.events[event]) !== null && _a !== void 0 ? _a : [];
        this.events[event].push(fct);
    };
    /* eslint-disable-next-line @typescript-eslint/ban-types */
    MicroEvent.prototype.unbind = function (event, fct) {
        if (!(event in this.events))
            return;
        this.events[event].splice(this.events[event].indexOf(fct), 1);
    };
    MicroEvent.prototype.trigger = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!(event in this.events))
            return false;
        for (var _a = 0, _b = this.events[event]; _a < _b.length; _a++) {
            var eventObject = _b[_a];
            eventObject.apply(null, args);
        }
        return true;
    };
    return MicroEvent;
}());
var domoEvents = new MicroEvent();
var channel = new MessageChannel();
var connected = false;
var connect = function () {
    if (connected)
        return;
    window.parent.postMessage(JSON.stringify({ event: 'subscribe' }), '*', [
        channel.port2,
    ]);
    channel.port1.onmessage = function (e) {
        var isHandled = domoEvents.trigger(e.data.event, e.data);
        var responsePort = e.ports[0];
        if (!Boolean(responsePort))
            return;
        responsePort.postMessage(isHandled ? {} : { error: 'Event not handled' });
    };
    connected = true;
};
var decode = function (input) { return decodeURIComponent(input.replace(/\+/g, ' ')); };
exports.DomoEvents = domoEvents;
var querystring = function (query) {
    var parser = /([^=?&]+)=?([^&]*)/g;
    var result = {};
    var part;
    while ((part = parser.exec(query))) {
        var key = decode(part[1]);
        var value = decode(part[2]);
        if (key in result)
            continue;
        result[key] = value;
    }
    return result;
};
exports.querystring = querystring;
var querystringify = function (obj, prefix) {
    var urlPrefix = prefix || '';
    var pairs = [];
    if ('string' !== typeof prefix)
        urlPrefix = '?';
    for (var key in obj) {
        if (Object.hasOwn(obj, key)) {
            pairs.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key])));
        }
    }
    return pairs.length ? urlPrefix + pairs.join('&') : '';
};
exports.querystringify = querystringify;
